import setLayout from '../../callbacks/set-layout'

export default function (router, store) {
  return async (to, from, next) => {
    if (!store.getters.authCheck && store.getters.authToken) {
      try {
        await store.dispatch('fetchUser')
      } catch (e) {
        //
      }
    }
    setLayout({router, store, to, from, next})
    next()
  }
}
